::ng-deep particle-numeric-ownership-cell-editor{display:flex;width:100%}::ng-deep particle-numeric-ownership-cell-editor form{width:100%}
/*# sourceMappingURL=numeric-ownership-cell-editor.component-LNC6TBG6.css.map */
